import { render, staticRenderFns } from "./BalanceFixedTopWidget.vue?vue&type=template&id=01365d38&"
import script from "./BalanceFixedTopWidget.vue?vue&type=script&lang=js&"
export * from "./BalanceFixedTopWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports